import { IOnInit } from "angular";

export class MachineDetailSpecificController implements IOnInit {
  static $inject = [];
  constructor() {}
  $onInit(): void {}
}
